// Logo URL

const urlForLogo = document.URL;
const logoLinkTag = document.querySelector(".logo_link_tag");

if(urlForLogo.includes("car")) {
    logoLinkTag.href = "javascript:void(0)";
    logoLinkTag.style.cursor = "default";
}

// Video Testimonials

window.addEventListener('DOMContentLoaded', ()=>{
    var glideMulti = new Glide('.glide', {
      type: 'carousel',
      autoplay: 3500,
      perView: 3,
      breakpoints: {
          700: {
        perView: 1
      }
    },
      gap: 30
      }).mount();
  
      document.querySelectorAll('.video-open').forEach((item)=>{
          item.addEventListener('click', (e)=>{
              e.preventDefault();
              document.querySelector('.modal').style.display = 'block';
              document.querySelector('.modal-content').insertAdjacentHTML('beforeend', `
                  <iframe width="500" height="500" src="https://player.vimeo.com/video/${item.dataset.url}?h=fbec6a3d9c&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style="min-height: 70vh; position:relative;top:0;left:0;width:100%;height:100%;"></iframe>
              `);
          });
      })
  })

function closeVideo(){
    document.querySelector('.modal').style.display = 'none';
    document.querySelector('.modal-content iframe').remove();
}

// Protect Your Respiratory System

const colors = document.querySelectorAll(".availableColor");
const image = document.querySelector(".color-image")

function clearActives() {
    colors.forEach(el => el.classList.remove("active"))
}

colors.forEach(el => {
    el.addEventListener("click", () => {
        if(el.classList.contains("active")) return;
        
        clearActives();
        el.classList.add("active")

        image.classList.remove("fadeIn")
        image.classList.add("fadeOut")

        setTimeout(() => {
            image.src=`https://cdn.shopify.com/s/files/1/0569/8220/8697/files/${el.dataset.value}.webp?v=1657540944`
            image.classList.add("fadeIn")
        }, 300)
    })
})

// Video 

const thumbnail = document.querySelector(".thumbnail");
const video = document.querySelector(".video-player")

thumbnail.addEventListener("click", () => {
  thumbnail.classList.toggle("hidden")
  video.play()
})

video.addEventListener("click", () => {
  thumbnail.classList.toggle("hidden")
  video.pause()
})

video.addEventListener("ended", () => {
  video.play()
})

// FAQ

document.querySelectorAll('.faq-element').forEach((item)=>{
    item.addEventListener('click', ()=>{
        item.classList.toggle('active')
    })
})